import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    all: [],
    some: [],
    total: 0,
    pages: -1,
    loading: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {

    case actions.SOME_TCCS_FETCHED:
        return { ...state, ...payload };

    case actions.ALL_TCCS_FETCHED:
        return { ...state, ...payload };

    case actions.TCCS_FETCH_LOADING:
        return { ...state, ...payload };

    case actions.TCC_UPDATED:
        if (tccIndex(payload, state.some) !== -1) {
            state.some[tccIndex(payload, state.some)] =
                {
                    ...payload,
                    stage: payload.tccs[payload.tccId].evaluation,
                    data: { ...state.some[tccIndex(payload, state.some)].data, ...payload.tccs[payload.tccId] },
                };
        }
        return { ...state };

    default:
        return state;
    }
};

const tccIndex = (payload, arr) =>
    arr.findIndex( s => s.tccId === payload.tccId && s.userId === payload.userId && s.classId === payload.classId);



// WEBPACK FOOTER //
// ./src/components/tccs/tccs.reducer.js